import component from "./ProfileAttentions.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAttentions"

export default wrapVueComponent(componentName, component)
